@if (!isStatic) {
  @if (external != 'true') {
    <a class="uilab-card" [routerLink]="link">
      @if (avatarsize == '') {
        <div
          class="uilab-card--thumbnail thumbnail"
          style="background-image:url({{ headerImageSourceUrl }});"
          >
        </div>
      }
      @if (avatarsize != '') {
        <div
          class="uilab-card--thumbnail thumbnail"
          style="background-image:url({{ headerImageSourceUrl }});"
          [style.background-size.px]="avatarsize"
          >
        </div>
      }
      <div class="uilab-card--content">
        <header class="uilab-card--header">
          <h4>{{ title }}</h4>
        </header>
        <div class="uilab-card--description">
          {{ description }}
        </div>
      </div>
    </a>
  }
  @if (external == 'true') {
    <a class="external uilab-card" [href]="link">
      @if (avatarsize == '') {
        <div
          class="uilab-card--thumbnail thumbnail"
          style="background-image:url({{ headerImageSourceUrl }});"
          >
        </div>
      }
      @if (avatarsize != '') {
        <div
          class="uilab-card--thumbnail thumbnail"
          style="background-image:url({{ headerImageSourceUrl }});"
          [style.background-size.px]="avatarsize"
          >
        </div>
      }
      <div class="uilab-card--content">
        <header class="uilab-card--header">
          <h4>{{ title }}</h4>
        </header>
        <div class="uilab-card--description">
          {{ description }}
        </div>
      </div>
    </a>
  }
} @else {
  <div class="uilab-card uilab-card--static">
    <div class="uilab-card--content">
      <header class="uilab-card--header">
        <h4>{{ title }}</h4>
      </header>
      <div class="uilab-card--description" [innerHTML]="content"></div>
    </div>
  </div>
}
